import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { useLang } from "../context/LangContext";
import { useTheme } from "../context/ThemeContext";

export default function Header() {
  const { mode, setMode, theme } = useTheme();
  const [menuOpen, setMenuOpen] = useState(false);
  const { lang, setLang } = useLang();

  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const texts = {
    ru: "Национальный статистический комитет Кыргызской Республики",
    en: "National Statistical Committee of the Kyrgyz Republic",
    kg: "Кыргыз Республикасынын Улуттук статистика комитети",
  };

  return (
    <header
      style={{
        position: "fixed",
        top: 0,
        left: 0, // ✅ важно
        right: 0, // ✅ важно (лучше чем width:100%)
        zIndex: 1000,

        backdropFilter: "blur(12px)",

        background:
          mode === "dark" ? "rgba(0,0,0,0.6)" : "rgba(255,255,255,0.7)",

        borderBottom: `1px solid ${theme.border}`,

        boxSizing: "border-box", // ✅ фикс переполнения
        overflow: "hidden", // ✅ защита от скролла
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "10px 16px",
          maxWidth: "1200px",
          margin: "0 auto",
        }}
      >
        {/* LEFT */}
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <img
            src="https://stat.gov.kg/static/images/logoruscolor.svg"
            alt="logo"
            style={{ width: isMobile ? "40px" : "50px" }}
          />

          {/* ❗ скрываем длинный текст на мобилке */}
          {!isMobile && (
            <div
              style={{
                fontSize: "clamp(10px, 1.2vw, 16px)",
                color: "#555",
                maxWidth: "300px",
              }}
            >
              {texts[lang]}
            </div>
          )}
        </div>

        {/* RIGHT */}
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          {/* DESKTOP */}
          {!isMobile && (
            <div style={{ display: "flex", gap: "8px" }}>
              {["ru", "en", "kg"].map((l) => (
                <button
                  key={l}
                  onClick={() => setLang(l)}
                  style={{
                    background: "#1976d2",
                    color: lang === l ? "#fff" : "black",

                    border: `1px solid ${lang === l ? "#1976d2" : "#1976d2"}`,

                    padding: "5px 12px",
                    borderRadius: "6px",
                    cursor: "pointer",
                    fontSize: "13px",
                    fontWeight: 500,

                    transition: "all 0.2s ease",

                    // 🎯 тень только у активной
                    boxShadow:
                      lang === l
                        ? "0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)"
                        : "none",
                  }}
                  // onMouseEnter={(e) => {
                  //   if (lang !== l) {
                  //     e.target.style.background = "rgba(25,118,210,0.08)"; // hover как MUI
                  //   }
                  // }}
                  // onMouseLeave={(e) => {
                  //   if (lang !== l) {
                  //     e.target.style.background = "transparent";
                  //   }
                  // }}
                >
                  {l.toUpperCase()}
                </button>
              ))}

              {/* THEME */}
              {/* <button
                onClick={() => setMode(mode === "light" ? "dark" : "light")}
                style={{
                  border: `1px solid ${theme.border}`,
                  background: "transparent",
                  borderRadius: "6px",
                  padding: "5px 8px",
                  cursor: "pointer",
                  color: theme.text,
                }}
              >
                {mode === "light" ? "🌙" : "☀️"}
              </button> */}
            </div>
          )}

          {/* MOBILE BURGER */}
          {isMobile && (
            <div
              onClick={() => setMenuOpen(!menuOpen)}
              style={{
                display: "flex",
                flexDirection: "column",
                cursor: "pointer",
              }}
            >
              <span
                style={{
                  width: "22px",
                  height: "2px",
                  background: theme.text,
                  marginBottom: "4px",
                }}
              />
              <span
                style={{
                  width: "22px",
                  height: "2px",
                  background: theme.text,
                  marginBottom: "4px",
                }}
              />
              <span
                style={{
                  width: "22px",
                  height: "2px",
                  background: theme.text,
                }}
              />
            </div>
          )}
        </div>
      </div>

      {/* MOBILE MENU */}
      {menuOpen && isMobile && (
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          style={{
            background: '#2563EB',
            padding: "20px",
            borderTop: `1px solid ${theme.border}`,
            display: "flex",
            flexDirection: "column",
            gap: "12px",
            alignItems: "center",
          }}
        >
          {["ru", "en", "kg"].map((l) => (
            <button
              key={l}
              onClick={() => {
                setLang(l);
                setMenuOpen(false);
              }}
              style={{
                background:  "#2563EB",
                color: lang === l ? "#fff" : 'black',
                border: `1px solid ${lang === l ? "#2563EB" : '#2563EB'}`,
                padding: "8px 16px",
                borderRadius: "8px",
                width: "100%",
                maxWidth: "200px",
              }}
            >
              {l.toUpperCase()}
            </button>
          ))}

          
        </motion.div>
      )}
    </header>
  );
}
